export const setChannelQueryFilters = (state, action) => {
  state.channelQuery.filters.channelId = action.payload.channelId
  state.channelQuery.filters.name = action.payload.name
  state.channelQuery.filters.tags = action.payload.tags
  state.channelQuery.filters.isDeleted = action.payload.isDeleted
}
